import React, {useEffect} from 'react';
import AIBackground from "../functions/AIBackground";

const PrivacyPolicy = () => {

   return(

    <>
<h1>Privacy Policy – PandaPick</h1>

<p><small>Last Updated: September 2, 2026</small></p>

<p>
PandaPick respects your privacy. We collect and use information necessary to provide employee attendance services, including employee account information, attendance records, and precise location data.
</p>

<p>
Location data is used to verify workplace attendance, check the employee's location against the designated workplace area, and support attendance check-in and check-out.
</p>

<p>
We may use third-party services such as Google AdMob to provide advertisements. These services may process certain device and advertising information according to their own privacy policies.
</p>

<p>
We use reasonable security measures to protect your information and do not sell personal or sensitive user data.
</p>

<p>
Attendance and account information is retained only as necessary to provide the service and meet applicable business or legal requirements. Users may request deletion of their account and associated personal data by contacting us.
</p>

<p>
For privacy questions or data deletion requests, contact:
</p>

<p>
<strong>Email:</strong> info@pandapick.in, info@techshiv.com<br></br>
<strong>Website:</strong> https://pandapick.in
</p>

<p>
PandaPick<br></br>
Privacy Policy
</p>
</>
   )

}

export default PrivacyPolicy;